module.exports = {
  menu: {
    home: 'Нүүр хуудас',
    game: 'Тоглоом',
    connect_login: 'Хэтэвч Холболт/Нэвтрэх',
    new_game: 'Тоглоомд орох',
    invite_friends: 'Найзуудаа урь',
    cms_login: 'CMS Нэвтрэх',
    register: 'Бүртгүүлэх',
    login: 'Нэвтрэх',
    logout: 'Гарах',
    login_to_play_game: 'Тоглоом тоглохын тулд нэвтрэх',
    select_login_method: 'Нэвтрэх арга сонгоно уу',
    select_register_method: 'Бүртгэлийн арга сонгоно уу',
    email: 'И-мэйл',
    meta_mask: 'MetaMask',
    player_login: 'Тоглогч Нэвтрэх',
    history: 'Түүх',
    transaction_history: 'Гүйлгээний Түүх',
    ranking: 'Тооцоо',
    purchase: 'Сэрэмжлүүлэг',
    search_game_placeholder: 'Тоглоом хайх..',
    new_games: 'Шинэ Тоглоомууд',
    frequent: 'Ийм тоглоом тоглож байгаа',
    faq: 'Ийм асуултууд',
    terms_and_conditions: 'Win4Poker Тоглоомын Нөхцөл ба Хүртэл',
    tnc: 'Нөхцөл ба Хүртэл',
    about_us: 'Бидний тухай',
    contact_us: 'Холбоо барих',
    settings: 'Тохиргоо',
    lucky_draw: 'Азтай Шилжилт',
    tournament: 'Тэмцээн',
    announcement: 'Мэдэгдэл',
    no_news: 'Мэдээлэл байхгүй',
    online: 'Онлайн',
    deposit: 'Нэвтрүүлэг',
    terms_1_title: 'Тоглолтын Эрэмбэлэл',
    terms_1_content:
      'Бүх тоглогчид нь 18 нас хүрсэн байх шаардлагатай бөгөөд хууль эрхийн хүрээнд бүртгүүлж тоглох боломжтой бүсэд бүртгүүлэх ёстой.',
    terms_2_title: 'Хэрэглэгчийн бүртгэл',
    terms_2_content: 'Тоглогчид албан ёсны вэбсайтаар дамжуулан бүртгэл үүсгэх шаардлагатай.',
    terms_3_title: 'Тоглоомын дүрэм',
    terms_3_content:
      'Бүх тоглоомууд нь стандарт покерын дүрэм дагаж мөрдөх ёстой бөгөөд аливаа хулгай үйлдэл нь хэрэглэгчийн дансыг түр зогсоох эсвэл хаахад хүргэж болно.',
    terms_4_title: 'Нэвтрүүлэг ба Тасалдал',
    terms_4_content:
      'Тоглогчид платформын төлбөрийн арга замыг ашиглан нэвтрүүлэг хийх ёстой бөгөөд тасалдал нь платформын боловсруулалтын хугацаагаар хийгдэнэ.',
    terms_5_title: 'Бэлэг хуваарилалт',
    terms_5_content:
      'Бэлэг нь тоглоомын үр дүнгээр хуваарилна бөгөөд тодорхой дүрэм тоглоом эхлэхийн өмнө тайлбарлагдана.',
    terms_6_title: 'Хариуцлагын Хязгаарлал',
    terms_6_content:
      'Платформ нь үйлчилгээгээ эсвэл бүтээгдэхүүнээ ашиглах явцад үүссэн аливаа алдагдал эсвэл гэмтэлд хариуцлага хүлээхгүй.',
    terms_7_title: 'Нууцлалын Хамгаалалт',
    terms_7_content:
      'Тоглогчийн хувийн мэдээлэл нууцлалд хамгаалагдана бөгөөд зөвхөн данс удирдлага ба тоглоомын зорилгоор л ашиглагдана.',
    terms_8_title: 'Нөхцөлүүдийг Засах',
    terms_8_content:
      'Платформ нь нөхцөл ба нөхцөлүүдийг ямар ч үед засварлах эрхийг хадгалдаг бөгөөд засваруудыг и-мэйл эсвэл вэбсайтын мэдэгдлээр тоглогчдод мэдэгдэнэ.',
  },
  common: {
    theme: 'Үндсэн Ажлын Хуудас',
    delete_record_confirm_msg: 'Устгахыг зөвшөөрч байна уу?',
    yes: 'Тийм',
    no: 'Үгүй',
    true: 'Үнэн',
    false: 'Худал',
    success: 'Амжилттай',
    loading: 'Ачаалж байна',
    or: 'эсвэл',
    delete: 'Устгах',
    login: 'Нэвтрэх',
    submit: 'Илгээх',
    apply: 'Хэрэглэх',
    cancel: 'Цуцлах',
    confirm: 'Зөвшөөрөх',
    back_to_lobby: 'Лобби руу буцах',
    email: 'И-мэйл',
    id_document: 'Түрийн Хэрэгсэл',
    all_in_game: 'Бүх влдгүй оролцоо покер',
    all_in_game_omaha: 'Бүх влдгүй оролцоо Омахa',
    regular: 'Тогтмол покер',
    regular_description: 'Тогтмол покер нь хязгааргүй тавьдаг аргаас явуулдаг',
    short: 'Богино картыг',
    short_description: 'Богино картыг покер нь 36 карт ашиглан тоглогддог',
    omaha: 'Омахa',
    omaha_description: 'Тоглогчид 2 картыг ашиглан гарцоо бүтээх ёстой',
    regular_allin: 'Бүх влдгүй оролцоо покер',
    omaha_allin: 'Бүх влдгүй оролцоо Омахa',
    tournament: 'Турнир',
    start: 'Хоол эхлэх',
    game_demo_area: 'Тоглоомын Туршилтын Бүс',
    total_win_prize: 'Нийт ялагчийн шагнал',
    waiting_list_order: 'Хүлээгдэж буй жагсаалтын дараалал',
    join_more_than_4_room_error: '4 өрөөнөөс илүүт оролцох боломжгүй',
    system_message: 'Системийн Мэдэгдэл',
    error: 'Алдаа',
    register: 'Бүртгүүлэх',
    meta_mask: 'MetaMask',
    wallet_connect: 'Хэтэвч Холболт',
    password: 'Нууц үг',
    next_step: 'Дараагийн алхам',
    next: 'Дараагийн',
    verify: 'Батлах',
    copy_success: 'Амжилттай хууллаа',
    enabled: 'Идэвхжсэн',
    enable: 'Идэвхжүүлэх',
    disable: 'Идэвхгүй болгох',
    done: 'Дууссан',
    feature_in_progress: 'Санал болгосон функц хөгжиж байгаа тул түр хүлээгээрэй.',
    no_data: 'Өгөгдөл байхгүй',
    date: 'Огноо',
    retry: 'Дахин оролдох',
    location_restricted_title: 'Байршлын хязгаарлалт',
    location_restricted_content:
      'Таны оршин байгаа бүс нутагт одоогоор хязгаарлалт тавигдсан байна. Зарим үйлдэл болон үйлчилгээнүүд боломжгүй байж болзошгүй. Таны ойлголтод талархал илэрхийлье.',
    dont_show_again: 'Дахин харуулахгүй',
    edit: 'Засах',
    i_am_not_located_in_the_restricted_country:
      'Байршлын хязгаарлалттай бүс нутагт одоогоор хязгаарлалт тавигдсан байна',
  },
  auth: {
    nickname: 'Нэр',
    connect_to_win_4_poker: 'WIN 4 POKER холбогдох',
    wallet_connect_need_to_connect_ur_wallet: 'Аппликейшн таны хэтэвч холболт шаарддаг',
    wallet_connect_sign_this_message:
      'Хэтэвчээ буцааж энэ мессежийг гарын үсэг зурж таны хэтэвчийн эзэмшигчийг баталгаажуулж үргэлжлүүлэхийг шаардана. Цуцлах нь холболтыг таслах болно.',
    sign_request_in_wallet: 'Хэтэвч дээр хүсэлтийг гарын үсэг зур',
    sign_message_success: 'Гарын үсэг зурж амжилттай',
    cancel: 'Цуцлах',
    sign: 'Гарын үсэг зурах',
    confirm_password: 'Нууц үгээ батлах',
    referral_code: 'Холбоосын код',
    i_have_read_the_agreement: 'Би гэрээг уншсан',
    should_accept_agreement: 'Гэрээг хүлээн зөвшөөрнө үү',
    alphabet_validation: 'Ядаж нэг үсгийн тэмдэгтийг агуулсан байх',
    numeric_validation: 'Ядаж нэг тоог агуулсан байх',
    length_validation: 'Ядаж 8 тэмдэгт, гэхдээ 20 тэмдэгтээс илүүгүй байх',
    placeholder: {
      enter_user_name: 'Хэрэглэгчийн нэрээ оруулна уу',
      enter_email: 'И-мэйлээ оруулна уу',
      enter_password: 'Нууц үгээ оруулна уу',
      confirm_password: 'Нууц үгээ баталгаажуулна уу',
      enter_referral_code: 'Холбоосын кодоо оруулна уу',
    },
    error_messages: {
      nickname: 'Таны нэрийг оруулна уу',
      email_invalid: 'Энэ нь хүчинтэй и-мэйл биш',
      email_required: 'Таны и-мэйлээ оруулна уу',
      password_required: 'Таны нууц үгээ оруулна уу',
      password_confirm_required: 'Таны нууц үгээ баталгаажуулна уу',
      password_confirm_not_matched: 'Та оруулсан хоёр нууц үг таарахгүй байна!',
      incorrect_email_or_password: 'И-мэйл эсвэл нууц үг буруу байна',
      error_occurred: 'Алдаа гарлаа, дараа дахин оролдоно уу',
    },

    // login-email page
    forget_password: 'Нууц үгээ мартсан үү？',

    // forgot-password page
    forgot_password_title: 'Нууц үгээ мартсан',
    please_enter_email_registered: 'Та бүртгэлтэй и-мэйлээ оруулна уу',

    // email-verification page
    email_verification: 'И-мэйл баталгаажуулалт',
    email_has_been_sent_to: 'И-мэйл илгээсэн {{value}} руу',
    email_resend_countdown_message:
      'И-мэйл хүлээн аваагүй үү？ Та <0>буцаан илгээх хугацаа</0> секунд хүлээж и-мэйл илгээх хүсэлтийг дахин хийх боломжтой',
    please_check_your_email: 'И-мэйлээ шалгана уу',
    waiting_to_verify_email: 'Таны и-мэйл баталгаажуулахыг хүлээж байна',
    agree_terms_and_privacy:
      'Хэрэв та энэ үйл явцыг үргэлжлүүлбэл бидний <0>нөхцөлүүд</0> ба <1>нууцлалын бодлогыг</1> хүлээн зөвшөөрсөн болно.',
    terms: 'Нөхцөлүүд',
    privacy_policy: 'Нууцлалын бодлого',

    // metamask-complete-registration page
    complete_metamask_registration: 'MetaMask бүртгэлийг дуусгах',

    // reset-password page
    reset_password: 'Нууц үгээ шинэчлэх',
    you_may_now_reset_password: 'Та одоо таны дансны нууц үгээ шинэчилж болно.',

    register_an_account: 'Хэрэв та бүртгэлгүй бол эндээс <0>бүртгүүлнэ үү</0>!',
    resend_code_message: 'И-мэйл хүлээн аваагүй үү？ энд дарж <0>кодыг дахин илгээх</0>',

    // 2FA setup page
    two_fa_via_email_title: 'И-мэйлээр Хоёр Давхар Баталгаажуулалт',
    otp_has_been_sent_to_email:
      'Нэг удаагийн баталгаажуулалтын код таны бүртгэсэн и-мэйл хаяг руу илгээгдсэн.',
    two_factor_authentication: 'Хоёр Давхар Баталгаажуулалт',
    scan_this_qr_code_msg:
      'Хоёр Давхар Баталгаажуулалтыг (2FA) тохируулахын тулд Authy эсвэл Google Authenticator зэрэг аппликейшн ашиглан энэ QR кодыг скан хийнэ үү.',
    choose_scan_qr_code_msg:
      'Баталгаажуулалтын аппликейшнийг нээж, доод баруун буланд "+" товчийг дарна уу. QR кодыг скан хийлнэ үү.',
    choose_enter_setup_key_msg:
      'Баталгаажуулалтын аппликейшнийг нээж, доод баруун буланд "+" товчийг дарна уу. Тохиргооны түлхүүрийг оруулахыг сонгоно уу.',
    secret_key: 'Нууц түлхүүр',
    enter_code_in_authenticator_app: 'Баталгаажуулалтын аппликейшнд харуулсан кодыг оруулна уу.',
    two_fa_is_set: {
      title: '2FA тохируулагдсан',
      message: 'Та 2FA тохируулагдсан бөгөөд тасалдалын функц одоо ашиглаж болно.',
    },

    // KYC page
    complete_email_verification_to_unlock_some_function:
      'XXX функцуудыг нээхийн тулд и-мэйл баталгаажуулалтыг дуусгаарай',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '100,000 USDT хүртэл тасалдалын хэмжээг нэмэгдүүлэхийн тулд тань тухайн үнэмлэхийн баталгаажуулалтыг дуусгах хэрэгтэй',

    requirement: 'Шаардлага',
    verify_now: 'Одоо баталгаажуулна уу',

    verification_code: 'Баталгаажуулах код',
    email_verification: {
      title: 'И-мэйл баталгаажуулалт',
      msg: 'Баталгаажуулах кодуудыг хүлээн авах боломжтой и-мэйл хаяг оруулна уу.',
      otp_has_been_sent_to: '{{value}} руу баталгаажуулах код илгээгдсэн',
    },

    id_card: 'Түрийн үнэмлэх',
    passport: 'Явах үнэмлэх',

    identity_verification: {
      title: 'Биеийн Баталгаажуулалт',
      msg: 'Биеийн үнэмлэхийг баталгаажуулахын тулд хүчинтэй үнэмлэхийг ашиглана уу.',
      issuing_country: {title: 'Үнэмлэх гаргасан орон сонгох', placeholder: 'Орон сонгох'},
      document_type: {
        title: 'Биеийн үнэмлэхийн төрөл сонгох',
        placeholder: 'Биеийн үнэмлэхийн төрөл сонгох',
      },
    },

    uploadDocument: {
      title: 'Файлыг оруулах',
      make_sure_that_your: 'Таны файлыг:',
      is_clear_and_easy_to_read: 'Цэвэр бөгөөд уншихад хялбар байх',
      is_unedited: 'Засварлагдаагүй байх',
      the_whole_doc_must_appear_in_photo: 'Бүх баримт бичиг зураг дээр харагдах байх',
      no_reflective_glare: 'Гэрэл эсвэл гэрэлтэлгүй байх',

      upload_image: 'Зургийг оруулах',
      upload_image_requirement:
        'Файлын хэмжээ нь 10MB-с бага байх ёстой бөгөөд jpeg эсвэл png форматыг дэмждэг.',
      front_side_of_id: 'Түрийн үнэмлэхийн урд тал',
      back_side_of_id: 'Түрийн үнэмлэхийн ард тал',
      personal_data_page_of_passport: 'Явах үнэмлэхийн хувийн мэдээллийн хуудас',
      document_uploaded: 'Баримт бичиг оруулсан',
      id_document_under_review_msg:
        'Таны биеийн үнэмлэхийг шалгаж байна, баталгаажуулахад 1-2 ажлын өдөр шаардлагатай байж магадгүй.',
    },

    disable_2fa: {
      title: 'Хоёр Давхар Баталгаажуулалтыг хаах',
      description:
        'Үргэлжлүүлэхийн тулд баталгаажуулах аппликейшнд гарсан баталгаажуулах кодоо оруулна уу',
      success_message: 'Та хоёр давхар баталгаажуулалтыг хаасан',
    },
    connect_wallet_to_spin: 'Төрөлт холбох',

    // enter code page
    link_email: 'Имэйл холбох',
    unlink_email: 'Имэйл хасах',
    expires_in: 'Хүрээлэгдэх <0>мин</0>.',
    resend_code: '<0>Код ирээгүй</0>',
    enter_code: 'Код оруулна уу',
    unlink_email_confirm_msg: 'Имэйл хасахдаа итгэлтэй байна уу?',
    link_success: 'Имэйл холбогдсон',
    unlink_success: 'Имэйл хасагдсан',
  },
  slider: {
    about: 'Тухай',
    support: 'Дэмжлэг',
  },
  game_room: {
    confirm_leave_msg: 'Тоглоомоос гарахыг зөвшөөрч байна уу?',
    join_room_error_title: 'Өрөөнд нэгдэх алдаа',
    join_room_error_msg: 'Өрөөнд нэгдэж чадсангүй, дахин оролдоно уу',
    confirm_withdraw_extra_bet_msg: 'Нэмэлт тоглоомын зээлийг татахыг зөвшөөрч байна уу?',
    total_won_prize: 'Нийт ялагчийн шагнал: ${{val, number}}',
    your_balance: 'Таны үлдэгдэл: ${{val, number}}',
    no_enough_balance:
      'Үлдэгдэл нь хамгийн бага худалдан авалтын зээлийн хэмжээ: ${{val, number}}-аас доош байна',
    cash_out: 'Мөнгө авах ба гарах',
    continue_game: 'Тоглоом үргэлжлүүлэх',
    remark_placeholder: 'Тайлбар',
    leave_seat: 'Сидлээс гарах',
    sit_in: 'Сидлдаа буцах',
    buy_in: 'Худалдан авах',
    buy_in_min_amount: 'Хамгийн бага',
    buy_in_max_amount: 'Хамгийн их',
    seconds: 'секунд',
    close_drawer: 'Хаах',
    leave_game: 'Тоглоомоос гарах',
    back_to_lobby: 'Лобби руу буцах',
    leave_table: 'Тавцнаас гарах',
    you_have_copied_room_code: 'Та өрөөнийн урилга кодыг хуулсан байна: {{value}}',
    invitation_message:
      '{{playerName}}-ийн үүсгэсэн өрөөнд даруй орно уу! Өрөөнийн урилга код: {{roomNumber}}, тоглоом эхлээрэй!',
    link_copied: 'Та холбоосыг амжилттай хуулсан байна',
    please_wait_until_connected: 'Холболтын хүлээн авах хүртэл хүлээнэ үү',
    rejoin_room: 'Өрөөнд буцаж ор',
    theme_setting: 'Гарчмын тохиргоо',
    room_code_share: 'Өрөөнийн урилга кодыг хуул',
    room_link_copy: 'Холбоосыг хуваалцах',
    table_setting: 'Тавцны тохиргоо',
    emoji_menu: 'Emoji цэс',
    history_drawer: 'Өрөөнийн түүх',
    deposit: 'Нэвтрүүлэг',
    withdraw_extra_bet: 'Нэмэлт тоглоомын зээлийг татах',
    add_extra_bet: 'Нэмэлт тоглоомын зээл нэмэх',
    unit_convert: 'Нэгж шилжүүлэх',
    silent_mode_on: 'Чимээгүй горим: Нээсэн',
    silent_mode_off: 'Чимээгүй горим: Хаасан',
    raise_to: 'Хураамж өгөх:',
    winner: 'Ялагч',
    player_status: {
      disconnected: 'Сул тал',
      sat_out: 'Сидлээс гарах',
    },
    win_percentage: 'Ялалтын хувь',
    all_in: 'Бүх влд',
    ping_popup_msg: 'Сүлжээний сигнал муутай, дахин холболтыг оролдож байна',
    ping_popup_title: 'Сүлжээний сигнал муутай',
    ping_popup_content: 'Дахин холболтыг оролдож байна, хуудсыг шинэчлэхийг оролдоорой',
    disconnected_modal_title: 'Сүлжээний сигнал муутай',
    afk_timer_text:
      'Таны удаан хариу үйлдэлгүй байсан тул тавцнаас гарал. Хугацаа дотор дахин ирэхгүй бол өрөөнөөс гарах болно',
    regular: 'Тогтмол покер',
    short: 'Богино картыг',
    omaha: 'Омахa',
    omaha_all_in: 'Бүх влдгүй оролцоо Омахa',
    buyin_option: 'Худалдан авалтын сонголт',
    buy_in_amount: 'Худалдан авалтын хэмжээ',
    reminder: 'Мэдэгдэл',
    not_enough_balance_to_buy_in: 'Худалдан авахад хангалттай үлдэгдэл байхгүй байна.',
    sitting_out: 'Сидлээс гарах',
    not_leaving_temporarily: 'Тухайн түр хугацаанд гарахгүй байна',
    back_to_home: 'Нүүр хуудас руу гарах',
    are_you_sure_leave_table:
      'Та хамгийн их зээлийг тавьсан тоглогч байна, гарахдаа итгэлтэй байна уу?',
    leave_table_with_highest_bet_error:
      'Та хамгийн их зээлийг тавьсан тоглогч байна, ширээнээс гарах боломжгүй. Дараа дахин оролдоно уу.',
    loading_room_data: 'Өрөөнийн өгөгдлийг ачаалж байна...',
    sit_out_tournament_warning: {
      title: 'Тэмцээнээс гарах анхааруулга',
      msg: 'Та одоо тэмцээнд оролцож байна. Хэрэв та гарвал, та мөн л блайндын төлбөр төлөх шаардлагатай.',
    },
  },
  player_action: {
    bet: 'Тоглох',
    call: 'Дуудлага',
    check: 'Гарах',
    raise: 'Хураамж өгөх',
    fold: 'Болих',
    bb: 'Их агны тавьдаг',
    sb: 'Жижиг агны тавьдаг',
    ante: 'Унд',
    all_in: 'Бүх влд',
    insurance_cancel: 'Даатгал цуцлах',
    insurance_buy: 'Даатгал батлах',
  },
  game_demo: {
    experience_progress: 'Туршилтын кодын үргэлжлэх байдал',
    game_experience_zone: 'Тоглоомын Туршилтын Бүс',
    action_to_redemption: '30 хүчинтэй тоглоомыг гүйцэтгэж бонустай код солих',
    remaining_game_experience_code: 'Түр хүлээгдэж буй {{val, number}} код',
    cash_code_exchange: 'Бонустай код солих',
    successfully_finish_30_games: 'Амжилттай дуусгасан',
    congrats: 'Танд баяр хүргэе!',
    successful_exchange_cash_code: '{{amount}} бонустай код амжилттай солигдсон',
    how_to_redeem: 'Туршилтын кодыг хэрхэн солих',
    successful_condition_of_redemption: 'Нөхцөл: 30 хүчинтэй тоглоомыг гүйцэтгэх',
    two_to_three_players: '2-3 тоглогчийн тал',
    explanation_of_valid_game: '10BB хүрсэн & тоглолтыг өөрөө нээлттэй байх, 1 тоглолт хүчинтэй',
    more_than_four_players: '4 эсвэл түүнээс дээш тоглогчийн тал',
  },
  userProfile: {
    profile_settings: 'Профайл тохиргоо',
    initial_setting_title: 'Win4.Poker-д тавтай морил',
    initial_setting_description:
      'Доорх анхан шатны тохиргоог дуусгаж, манай тоглоомыг эдлэхийг хүсч байна',
    display_name: 'Тоглогчийн нэр',
    profile_picture: 'Тоглогчийн нүүр зураг',
    edit: 'Засах',
    balance: 'Үлдэгдэл',
    coin: 'USD',
    demo_coin: 'Бонустай код',
    diamond: 'Алтан',
    game_record: 'Тоглоомын Түүх',
    ranking_list: 'Тооцооны Жагсаалт',
    game_review: 'Тоглоомын Хяналт',
    shortcut_setting: 'Товчлуур тохиргоо',
    user_name: 'Хэрэглэгчийн нэр:',
    recommend_code: 'Санал болгосон код',
    upload_image_msg: 'Зураг ийм газар чирж оруулаарай, эсвэл',
    upload_image_browser_msg: 'Хөтөч',
    upload_image_file_size: '(Файлын хэмжээ хамгийн их: 68px*93px)',
    username_length_message: 'Хэрэглэгчийн нэрийн урт 3-24 тэмдэгтийн хооронд байх ёстой',
    chinese_username_length_message:
      'Хятад тэмдэгт агуулсан хэрэглэгчийн нэрийн урт 1-5 тэмдэгтийн хооронд байх ёстой',
    username_char_message:
      "Хэрэглэгчийн нэр нь зөвхөн үсэг, тоо, Хятад тэмдэгт болон '_'/'-'/'.' агуулж болно",
    personal_information: 'Хувийн мэдээлэл',
    user_icon: 'Хэрэглэгчийн нүүр зураг:',
    save: 'Хадгалах',
    my_profile: 'Миний Профайл',
    my_balance: 'Миний Үлдэгдэл',
    deposit_withdraw: 'Нэвтрүүлэг/Тасалдал',
    my_record: 'Миний Түүх',
    flow_record: 'Гүйлгээний Түүх',
    total_earnings: 'Нийт орлого',
    country: 'Улс',
    disclaimer: 'Шинэчилгээний анхааруулга',
  },
  maintenance: {
    title: 'Вэбсайт засварын явцад байна',
    content:
      'Бид хэрэглэгчийн туршлагыг сайжруулахын тулд хүчин чармайж байна. Бид хурдан буцаж ирэх болно. Таны тэвчээрийг үнэлж байна.',
  },
  useSetting: {
    card_front: 'Картыг урд тал',
    card_back: 'Картыг ард тал',
    table: 'Тавцан',
    add_token_msg: 'Илүү токен нэмэх шаардлагатай байна уу?',
  },
  lucky_draw: {
    award_history: 'Шагналын түүх',
    lucky_draw_rules: 'Дүрэм',
    remaining_lucky_draw_amount: 'Үлдсэн эргэлт: {{value}}',
    remaining_lucky_draw_amount_loading_label: 'Үлдсэн эргэлт: ',
    spin_wheel_10_times: 'Дугуйг 10 удаа эргүүлэх',
    spin_wheel: 'Дугуйг эргүүлэх',
    participation_rate: 'Тоглоомын оролцоо: {{count}}',
    coin_loss: 'Зоосны алдагдал',
    congrats: 'Баяр хүргэе!',
    you_have_won: 'Та ${{prize}} хожлоо',
    collect_prize: 'Шагналаа аваарай',
    select_category: 'Сугалааны ангиллыг сонгоно уу: ',
    special_combination: 'Тусгай хослол: ',
    no_history: 'Сугалааны түүх олдсонгүй',
    no_data: 'Мэдээлэл байхгүй',
    spin: 'Эргүүлэх',
    fortune_wheel: 'Азын дугуй',
    christmas_fortune_wheel: 'Зул сарын азын дугуй',
    new_year_fortune_wheel: 'Шинэ жилийн азын дугуй',
    cny_fortune_wheel: 'Хятадын Шинэ жилийн азын эргэлт',
    email_login: 'Имэйлээр нэвтрэх',
    thank_you: 'Баярлалаа',
    miss_msg_1:
      'Манай үйл ажиллагаанд оролцсон танд баярлалаа. Та үлдсэн эргэлтгүй байна. Илүү их мөнгө хожихын тулд манай тоглоомд оролцоорой. Амжилт хүсье!',
    play_now: 'Одоо тоглох',
    win_msg: 'Та ялсан <br/> <large>{{prize}}</large> <br /> бөгөөд таны тэнцэлд хадгалагдсан.',
    draw_again_msg:
      'Танд <yellow>{{numOfDraws}}</yellow> сугалаа үлдсэн. <clickable>Дахин сугалаа татахын тулд дарна уу.</clickable>',
    diamond: '{{value}} Алмаз',
    redeem_now: 'Одоо солих',

    deposit_more_than_10: '$10-С ИЛҮҮ БАЙРЛУУЛАХ',
    get_1_free_spin: '1 ҮНЭГҮЙ ЭРГЭЛТ АВАХ',
    win_10_times: '10 УДАА ХОЖИХ',
  },
  combination: {
    hi_card: 'Өндөр картыг',
    pair: 'Нэг хос',
    one_pair: 'Нэг хос',
    two_pairs: 'Хоёр хос',
    set: 'Гурван карт',
    three_of_a_kind: 'Гурван карт',
    straight: 'Цутгал',
    flush: 'Цэцэг',
    fullHouse: 'Бүтэн Байшин',
    full_house: 'Бүтэн Байшин',
    quad: 'Дөрөв карт',
    straight_flush: 'Цэцэгцүү цутгал',
    royal_flush: 'Цэцэгцүү хаалтын цутгал',
  },
  room_type: {
    public: 'Олон нийтэд нээлттэй өрөө',
    private: 'Хувийн өрөө',
  },
  forgot_password: {
    reset_password: 'Нууц үгээ шинэчлэх',
    password: 'Нууц үг',
    confirm_password: 'Нууц үгээ баталгаажуулах',
    phone: 'Утас',
  },
  error: {
    please_confirm: 'Баталгаажуулах хэрэгтэй',
    password_inconsistent: 'Нууц үг тохирохгүй байна',
    file_size_limit_error: 'Файлын хэмжээ хязгаар: {{size}}',
    please_input: '{{field}} оруулна уу',
  },
  translation: {
    success: 'Амжилттай',
  },
  game_list: {
    table: 'Тавцан',
    random_join_table: 'Санамсаргүй өрөөнд нэгдэх',
    random_join: 'Санамсаргүй нэгдэх',
    join: 'Нэгдэх',
    no_room_available: 'Өрөө байхгүй, дараа дахин оролдоно уу.',
    all_game_loaded: 'Бүх тоглоомууд ачаалсан',
    join_waiting_list: 'Хүлээгдэж буй жагсаалтанд нэгдэх',
    join_table: 'Тавцанд нэгдэх',
    join_observer: 'Хяналт',
    game_code: 'Тавцны код',
    game_type: 'Тоглоомын төрөл',
    game_limit: 'Хүний дээд хэмжээ',
    game_players: 'Тоглогчид',
    game_unit_test: 'Нэгж туршилт',
    game_basicBet: 'Ерөнхий тавьдаг',
    game_SB: 'SB',
    game_smallBlind: 'Жижиг агны тавьдаг',
    regular: 'Тогтмол покер',
    all_in: 'Бүх влдгүй оролцоо покер',
    short: 'Богино картыг',
    omaha: 'Омахa',
    omaha_all_in: 'Бүх влдгүй оролцоо Омахa',
    buy_in: 'Худалдан авах',
    tables: 'Тавцан',
    notice: 'Мэдэгдэл',
    time_difference_reminder:
      'Таны системийн цаг болон интернет цаг дундад үйлчлүүлэгчийн тооцооны функц дээр сөрөг нөлөө үзүүлэх боломжтой учир системийн цагийг нийцүүлнэ үү.',
    player_category: 'Тоглогчийн ангилал',
    blind_category: 'Агны тавьдаг ангилал',
    table_category: 'Тавцны ангилал',
    chips: 'Токен',
    player: 'Тоглогч',
    waiting: 'Хүлээж буй',
    avg_pot: 'Дундаж пот',
    flop_rate: 'Флопийн хувь',
    hands_per_hour: 'Цаг тутамд гарсан гараа',
    no_of_hands_played: 'Нийт гарсан гараа',
    win: 'Ялалт',
    invested: 'Хөрөнгө оруулалт',
    pot: 'Пот',
    usd_balance_updated: 'Америк долларын үлдэгдэл ${{balance}} болж шинэчлэгдлээ',
    new_room: 'Шинэ өрөө',
    game: 'Мөнгөн тоглоом',
    tournament: 'Тэмцээн',
  },
  game_review: {
    my_bets: 'Миний тавьдаг',
    date_range: 'Огнооны хүрээ',
    select_date_range: 'Огнооны хүрээг сонгоно уу',
    show_all_dates: 'Бүх огноог харуулах',
    show_selected_dates: 'Сонгосон огноог харуулах',
    no_game_record: 'Тоглоомын бүртгэл байхгүй',
    win_row_message: 'ЯЛАЛ!!',
    lose_row_message: 'Зардал',
    ante: 'Унд',
    win: 'Ялалт',
    lose: 'Алдагдал',
    main_pot: 'Үндсэн Пот',
    side_pot: 'Гарааны Пот {{number}}',
  },
  leader_board: {
    rank: 'Байр',
    name: 'Нэр',
    win_game: 'Нийт ялалт',
    score: 'Үнэлгээ',
  },
  home: {
    dont_miss_promotion_msg: 'Тэднийг алдсангүй',
    all_promotions: 'Бүх сурталчилгаа',
    my_game: 'Миний тоглоом',
    all_games: 'Бүх тоглоомууд',
    claim_first_time_reward_button: 'Мэдэх',
    first_time_login: 'Тоглоомд анх нэвтэрсэн',
    first_time_reward_msg: 'Та {{val}} туршилтын токен авна',
    open_table: 'Тавцан нээх',
    open_new_room: 'Шинэ өрөө нээх',
    enter_room_number: 'Өрөөний код оруулна уу',
    start: 'Эхлүүлэх',
    enter_code: 'Тасалдалын код оруулна уу',
    confirm: 'Зөвшөөрөх',
    game_selection: 'Тоглоом сонголт',
    start_game: 'Тавцан нээх/Өрөөнд нэгдэх',
    game_record: 'Тоглоомын түүх',
    join_private_room: 'Хувийн өрөөнд нэгдэх',
    roomCode: 'Өрөөний код',
    please_enter_a_valid_room_code: 'Үр дүнтэй тасалдалын код оруулна уу',
    notice: 'Мэдэгдэл',
    time_difference_reminder:
      'Таны системийн цаг болон интернет цаг дундад үйлчлүүлэгчийн тооцооны функц дээр сөрөг нөлөө үзүүлэх боломжтой учир системийн цагийг нийцүүлнэ үү. Хэрэв нийцүүлсэн бол хуудсыг дахин ачаалахыг оролдно уу.',
    register_success: 'Бүртгэл амжилттай',
    referral_code: 'Холбоосын код',
    referral_code_placeholder: 'Холбоосын код оруулна уу',
    display_name: 'Нэр харагдах',
    display_name_placeholder: 'Нэр харагдах оруулна уу',
    user: 'Тоглогч',
    bet_amount: 'Тавьдаг хэмжээ',
    date: 'Огноо',
    multiplier: 'Нэмэгдүүлэх',
    payout: 'Шагнал авах',
    free_game: 'Үнэгүй тоглоом',
    play_without_money: 'Мөнгөгүй тоглох',
    private_game: 'Хувийн өрөө',
    play_with_friends: 'Найзуудаа хамт тоглох',
    regular_content: 'Тогтмол покер нь хязгааргүй тавьдаг аргаас явуулдаг',
    all_in_content: 'All-In эсвэл Fold покер нь хязгааргүй тавьдаг аргаас явуулдаг',
    short_content: 'Богино картыг покер нь хязгааргүй тавьдаг аргаас явуулдаг',
    omaha_content: 'Пот хязгаарласан Омахa нь хязгааргүй тавьдаг аргаас явуулдаг',
    omaha_all_in_content: 'All-In эсвэл Fold Омахa нь хязгааргүй тавьдаг аргаас явуулдаг',
    player_statistics: 'Тоглогчийн байдал',
    lucky_draw_reminder: {
      title: 'Сануулах',
      message: '{{value}} удаан эргэлт үлдсэн байна',
      go_to_lucky_draw: 'Азын эргэлт рүү явах',
      spin_now: 'Одоо эргэлт хийх',
    },
  },
  disclaimer: {
    title: 'Тодорхойлолт',
    message:
      'Хэрэв та доорх хязгаарлагдмал бүсэд амьдарч байвал win4.poker дээр тоглохыг зөвшөөрөхгүй',
    countryList:
      'АНУ, Турк, Аруба, Bonaire, Curacao, Франц, Нидерланд, Швед, Израиль, Литва, Словак, Бельги, Швейцари, Saba, St. Eustatius, St. Martin, Хятад, Их Британи.',
    checkbox_message:
      'Би зарим бүсэд гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй гэмтээхгүй.',
    checkbox_message:
      'Би миний оршин суугаа газарт гэмтээхийг хориглохоор албан ёсны эрх бүхий байгууллагууд огт тоглохийг зөвшөөрөхгүйг баталж байна, мөн би 18 нас хүрсэн.',
    required_message: 'Тодорхойлолтыг зөвшөөрөх шаардлагатай',
  },
  login: {
    user_account: 'Хэрэглэгчийн нэр',
    password: 'Нууц үг',
    cash_web_login: 'Мөнгөний вэб хэрэглэгч нэвтрэх',
    player_register: 'Тоглогч бүртгүүлэх',
    gateway_user_name: 'Gateway хэрэглэгчийн нэр',
    cms_login: 'CMS Нэвтрэх',
    deposit: 'Нэвтрүүлэг',
    deposit_amount: 'Нэвтрүүлэгийн хэмжээ',
    deposit_message: 'Нэвтрүүлэгийн хэмжээг бөглөх шаардлагатай',
    notice: 'Мэдэгдэл',
    duplicate_login: 'Ижил IP-тай нэвтрэхийг илрүүлсэн',
    redirecting: 'Таны хуудсанд хурдан ачаалагдах бөгөөд тэвчээртэй хүлээнэ үү.',
    loading: 'Ажлыг ачаалж байна, түр хүлээнэ үү...',
  },
  verification: {
    email_verification_code: 'И-мэйл баталгаажуулах код',
    email_not_verify_error: 'И-мэйл баталгаажуулагдаагүй',
    confirm: 'Зөвшөөрөх',
    timer_count: 'Цагийн тоо',
    resend_verification_code: 'Баталгаажуулах кодыг дахин илгээх',
    send_verification_code: 'Баталгаажуулах код илгээх',
    input_field: '{{field}} оруулна уу',
    code: 'Код',
    successful_verify: 'Амжилттай баталгаажуулсан',
    two_factor_authentication: 'Хоёр Давхар Баталгаажуулалт',
    verification: 'Баталгаажуулалт',

    // KYC page
    verify: 'Баталгаажуулах',
    security: 'Аюулгүй байдал',

    kyc_status: {
      failed_verify_again: 'Баталгаажуулалт амжилтгүй болсноор дахин оролдоно',
      under_review: 'Баталгаажуулах явцад байна',
      verify_now: 'Одоо баталгаажуулах',
    },

    complete_email_verification_to_unlock_some_function:
      'XXX функцуудыг нээхийн тулд и-мэйл баталгаажуулалтыг дуусгаарай',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '100,000 USDT хүртэл тасалдалын хэмжээг нэмэгдүүлэхийн тулд тань тухайн үнэмлэхийн баталгаажуулалтыг дуусгах хэрэгтэй',
    requirement: 'Шаардлага',
    verify_now: 'Одоо баталгаажуулна уу',

    verification_code: 'Баталгаажуулах код',
    email_verification: {
      title: 'И-мэйл баталгаажуулалт',
      msg: 'Баталгаажуулах кодуудыг хүлээн авах боломжтой и-мэйл хаяг оруулна уу.',
      otp_has_been_sent_to: '{{value}} руу баталгаажуулах код илгээгдсэн',
    },

    id_card: 'Түрийн үнэмлэх',
    passport: 'Явах үнэмлэх',

    identity_verification: {
      title: 'Биеийн Баталгаажуулалт',
      msg: 'Биеийн үнэмлэхийг баталгаажуулахын тулд хүчинтэй үнэмлэхийг ашиглана уу.',
      issuing_country: {title: 'Үнэмлэх гаргасан орон сонгох', placeholder: 'Орон сонгох'},
      document_type: {
        title: 'Биеийн үнэмлэхийн төрөл сонгох',
        placeholder: 'Биеийн үнэмлэхийн төрөл сонгох',
      },
    },

    uploadDocument: {
      title: 'Файлыг оруулах',
      make_sure_that_your: 'Таны файлыг:',
      is_clear_and_easy_to_read: 'Цэвэр бөгөөд уншихад хялбар байх',
      is_unedited: 'Засварлагдаагүй байх',
      the_whole_doc_must_appear_in_photo: 'Бүх баримт бичиг зураг дээр харагдах байх',
      no_reflective_glare: 'Гэрэл эсвэл гэрэлтэлгүй байх',

      upload_image: 'Зургийг оруулах',
      upload_image_requirement:
        'Файлын хэмжээ нь 10MB-с бага байх ёстой бөгөөд jpeg эсвэл png форматыг дэмждэг.',
      front_side_of_id: 'Түрийн үнэмлэхийн урд тал',
      back_side_of_id: 'Түрийн үнэмлэхийн ард тал',
      personal_data_page_of_passport: 'Явах үнэмлэхийн хувийн мэдээллийн хуудас',
      document_uploaded: 'Баримт бичиг оруулсан',
      id_document_under_review_msg:
        'Таны биеийн үнэмлэхийг шалгаж байна, баталгаажуулахад 1-2 ажлын өдөр шаардлагатай байж магадгүй.',
    },

    disable_2fa: {
      title: 'Хоёр Давхар Баталгаажуулалтыг хаах',
      description:
        'Үргэлжлүүлэхийн тулд баталгаажуулах аппликейшнд гарсан баталгаажуулах кодоо оруулна уу',
      success_message: 'Та хоёр давхар баталгаажуулалтыг хаасан',
    },

    error_messages: {
      document_upload_required: 'Баримт бичгийг оруулна уу',
      selection_required: 'Сонголт хийх шаардлагатай',
    },
  },
  table_area: {
    pot: 'Пот',
    waiting_for_other_players: 'Бусад тоглогчид сууна гэж хүлээж байна...',
    waiting_for_game_start: 'Тоглоом эхлэхийг хүлээж байна',
    sixty_sec: '60 секунд',
    please_select_emoji_target: 'Тоглогч сонгоно уу',
  },
  best_combination: {
    hi_card: 'Өндөр картыг ({{value}})',
    one_pair: 'Нэг хос ({{value}})',
    two_pairs: 'Хоёр хос ({{firstPair}}, {{secondPair}})',
    set: 'Гурван карт ({{value}})',
    straight: 'Цутгал ({{fromValue}}-ээс {{toValue}})',
    flush: 'Цэцэг ({{value}} өндөр картыг)',
    fullHouse: 'Бүтэн Байшин ({{three_cards}} ба {{two_cards}})',
    quad: 'Дөрөв карт ({{value}})',
    straight_flush: 'Цэцэгцүү цутгал ({{fromValue}}-ээс {{toValue}})',
    royal_flush: 'Цэцэгцүү хаалтын цутгал',
  },
  action_buttons: {
    place_bet: 'Тавьдаг тавих',
    all_in: 'Бүх влд',
    bet: 'Тавьдаг',
    check: 'Гарах',
    call: 'Дуудлага',
    raise: 'Хураамж өгөх',
    fold: 'Болих',
    pot: 'Пот',
    confirm: 'Зөвшөөрөх',
    investment: 'Хөрөнгө оруулалт',
    insurance: 'Даатгал',
    choosing_cards: 'Картыг сонгох',
    outs_number: 'OUTS тоо',
    insurance_winning_rate: 'Ялалтын хувь',
    odds: 'Тавилгатай хувь',
    premium: 'Даатгалын хэмжээ',
    payout: 'Шагнал авах',
    call_any: 'Автомат дуудлага',
    wait_for_blinds: 'Агны дараах оролцоо',
    join_directly: 'Дараагийн луу оролцох',
    check_or_fold: 'Гарах / Болих',
    confirm_to_fold: 'Болихыг зөвшөөрч байна уу?',
    max: 'Хамгийн их',
    min: 'Хамгийн бага',
    force_insurance: 'Хязгаарласан даатгал',
  },
  history_drawer: {
    title: 'Өрөөнийн түүх',
    small_blind: 'Жижиг агны тавьдаг (Унд)',
    pre_flop: 'Флопийн өмнө',
    flop: 'Флоп',
    turn: 'Тоглолт',
    river: 'Гарц',
    no_data: 'Өрөөнийн өгөгдөл байхгүй',
    hands: 'Гараа',
    winner: 'Ялагч',
    buy_in: 'Худалдан авах',
    pool: 'Пот',
    win_player: 'Ялалт тоглогч',
    time: 'Цаг',
    main_pot: 'Үндсэн Пот',
    side_pot_one: 'Гарааны Пот 1',
    side_pot_two: 'Гарааны Пот 2',
    side_pot_three: 'Гарааны Пот 3',
    win: 'Ялалт',
    loading: 'Ачаалж байна',
    all_record_loaded: 'Бүх өрөөнийн түүхийг ачаалсан',
    previous_page: 'Өмнөх хуудас',
    close: 'Хаах',
    detail: 'Дэлгэрэнгүй',
  },
  file_upload: {
    upload: 'Оруулах',
  },
  user_menu: {
    two_factor: 'Хоёр Давхар Баталгаажуулалт',
    change_password: 'Нууц үгээ солих',
    logout: 'Гарах',
    hello_user: 'Сайн байна уу',
  },
  change_password_board: {
    change_password: 'Нууц үгээ солих',
    old_password: 'Хуучин нууц үг',
    new_password: 'Шинэ нууц үг',
    confirm_password: 'Нууц үгээ баталгаажуулах',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: 'Хайх..',
    filter: 'Шүүлтүүр',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: 'Унших',
    write: 'Бичих',
    none: 'Байхгүй',
    banned: 'Хоригдсон',
  },
  phone_input: {
    invalid_country_code: 'Үхэндээ алдаатай улс орон код',
    invalid_phone: 'Үхэндээ алдаатай утасны дугаар',
    phone_number: 'Утасны дугаар',
    phone_code: 'Тоо',
  },
  room_setting_drawer: {
    create_new_room: 'Шинэ өрөө үүсгэх',
    enter_room_code: 'Өрөөний код оруулах',
    please_enter_a_valid_room_code: 'Үр дүнтэй тасалдалын код оруулна уу',
    please_input_room_code: 'Өрөөний код оруулна уу',
    enter_room: 'Өрөөнд орох',
    room_setting: 'Өрөөний тохиргоо',
    small_blind: 'Жижиг агны тавьдаг:',
    ante: 'Унд:',
    buy_in: 'Нэвтрүүлэг:',
    number_of_people: 'Хүний тоо:',
    action_time: 'Үйл ажиллагааны цаг:',
    game_duration: 'Тоглоомын хугацаа:',
    commission: 'Хураамж:',
    insurance: 'Даатгал:',
    location_restriction: 'Байршлын хязгаарлал',
    diamond_needed: 'Шаардлагатай алтан:',
    diamond_owned: 'Одоогийн алтан:',
    redeem: 'Алтан худалдан авах',
    open_room: 'Өрөө үүсгэх',
    maximum: 'Хамгийн их:',
    hours: '{{value}} цаг',
    minute: '{{value}} минут',
    second: '{{value}} секунд',
    affect_diamond_needed: 'Шаардлагатай алтан дээр нөлөөлөх',
    remaining_room_time: 'Өрөөний дуусах хугацаа үлдсэн',
    diamond_require: 'Шаардлагатай алтан:',
    time_increase: 'Цаг нэмэгдүүлэх:',
    recharge: 'Сэргээх',
    isAllIn: 'Бүх влд',
    ipchecking: 'IP хязгаарлал',
    diamond_not_enough: 'Алтан үлдэгдэл хангалтгүй байна',
  },
  gameRecharge: {
    sticker_title: 'Sticker',
    check_for_more: 'Дэлгэрэнгүй харах',
    diamond_title: 'Алтан',
    diamond_product_tag: '{{value}} алтан',
    buy_diamond_confirm_msg: 'Алтан худалдан авалт батлах',
    buy_sticker_confirm_msg: 'Энэ sticker-г худалдан авах уу?',
    balance_not_enough_msg: 'Таны үлдэгдэл хангалтгүй байна',
    sticker_product_tag: '{{value}} алтан шаардах',
    confirm_to_buy_button: 'Зөвшөөрөх',
    confirm_title: 'Алтан худалдан авалт батлах',
    confirm_message:
      'Та USD$ <0>{{usdAmount}}</0> ашиглан <1>{{diamondAmount}} алтан</1> худалдан авахыг зөвшөөрч байна уу?',
    redeem: 'Сэргээх',
    confirm: 'Зөвшөөрөх',
    reminder: 'Мэдэгдэл',
    not_enough_money: 'Уучлаарай, таны үлдэгдэл хангалтгүй байна алтан худалдан авахад.',
    not_enough_diamond: 'Таны алтан үлдэгдэл хангалтгүй байна, түрээр алтан худалдан авна уу.',
    quanity: 'Тоо:',
    price: 'Үнэ:',
    diamond: 'Алтан',
    sticker: 'Sticker',
    purchase_success: 'Худалдан авалт амжилттай',
    purchase: 'Худалдан авах',
    diamond_balance: 'Алтан үлдэгдэл',
    free_sticker: 'Энэ үнэгүй бараа',
    amount_required: 'Тоо хэмжээг бөглөх шаардлагатай',
    valid_amount: 'Үр дүнтэй тоог оруулна уу',
    not_enough_diamond_balance: 'Алтан үлдэгдэл хангалтгүй байна',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: 'Бүх',
      usd: 'USD',
      cash: 'Бонустай код',
      diamond: 'Алтан',
    },
    transactionType: {
      createRoom: 'Хувийн өрөө үүсгэх',
      luckyDraw: 'Азтай шилжилт тоглох',
      purchaseItem: 'Sticker худалдан авах',
      purchaseDiamond: '{{value}} алтан худалдан авах',
      joinGame: '{{value}} тоглоомд оролцох',
      winGame: '{{value}} тоглоом ялсан',
      loseGame: '{{value}} тоглоом алдсан',
      winGameWithoutGameType: 'Тоглоом ялсан',
      loseGameWithoutGameType: 'Тоглоом алдсан',
      joinGameWithoutGameType: 'Тоглоомд оролцсон',
      deposit: 'Нэвтрүүлэг',
      redeemDemo: 'Бонустай код солих',
      insurance: 'Даатгал',
      gift: 'Бэлэг',
      firstLogin: 'Анхны нэвтрэх',
      privateRoomRebate: 'Хувийн өрөөний буцаан авалт',
    },
    transactionRecord: 'Гүйлгээний түүх',
    no_transaction_record: 'Гүйлгээний түүх байхгүй',
    currentMonth: 'Одоогийн сар',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: 'Энэ sticker-г худалдан авах уу?',
    sticker_product_tag: '{{value}} алтан шаардах',
    confirm_to_buy_button: 'Худалдан авалт батлах',
    emoji: 'Emoji',
    free: 'Үнэгүй',
    no_available_emoji: 'Бараа Emoji байхгүй',
  },
  playerInfo: {
    button: 'Байшин',
    smallBlind: 'Жижиг агны тавьдаг',
    bigBlind: 'Их агны тавьдаг',
    cutOff: 'Ханзан',
    underTheGun: 'Таван дээр',
    bet: 'Тавьдаг',
    check: 'Гарах',
    call: 'Дуудлага',
    raise: 'Хураамж өгөх',
    fold: 'Болих',
    cancelInsurance: 'Даатгал цуцлах',
    confirmInsurance: 'Даатгал батлах',
    allIn: 'Бүх влд',
    skip: 'Алгасах',
  },
  deposit_withdraw: {
    currency_usdt: 'Tether (USDT)',
    deposit_method: 'Хадгаламжийн арга',
    remark: 'Тайлбар',
    ton_connect: 'TON холболт',
    manual_deposit: 'Гар аргаар хадгаламж',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: 'Нэвтрүүлэг',
    withdraw: 'Тасалдал',
    withdrawal: 'Тасалдал',
    history: 'Нэвтрүүлэг/Тасалдалын түүх',
    blockchain: 'Блокчейн',
    currency: 'Мөнгөний нэгж',
    network: 'Сүлжээ',
    exchange_rate: 'Солилцооны хувь',
    deposit_address: 'Нэвтрүүлэгийн хаяг',
    deposit_process_message_1:
      'Систем нь мөнгийг хүлээн авсны дараа нэвтрүүлэгийг шуурхай боловсруулах бөгөөд процесс нь ойролцоогоор хоёр цаг шаардлагатай, тэвчээртэй хүлээж байгаарай.',
    back: 'Буцах',
    address: 'Хаяг',
    transaction_id: 'Гүйлгээний дугаар',
    amount: 'Тасалдалын хэмжээ',
    time: 'Цаг',
    coin_type: 'Мөнгөний төрөл',
    available_amount: 'Тасалдал хийх боломжтой хэмжээ',
    withdraw_amount: 'Тасалдалын хэмжээ',
    withdraw_cost: 'Тасалдалын зардал',
    receiving_amount: 'Хүлээгдэж буй хүлээн авалт',
    deposit_amount: 'Нэвтрүүлэгийн хэмжээ',
    deposit_amount_placeholder: 'Нэвтрүүлэгийн хэмжээ оруулна уу',
    no_data: 'Өгөгдөл байхгүй',
    address_placeholder: 'Хаяг оруулна уу',
    amount_placeholder: 'Тоо хэмжээ оруулна уу',
    withdrawal_amount: 'Тасалдалын хэмжээ',
    withdrawal_fee: 'Тасалдалын зардал',
    max: 'Хамгийн их',
    available_cash_out_balance: 'Тасалдал хийх боломжтой үлдэгдэл',
    cash_out_info:
      'Тоглоомд оролцсноор та зөвхөн покерын тоглоомоор ялсан USDT-г татаж авна, эсвэл тоглоомын тэнцүү үед татаж авна.',
    wallet_balance: 'Хэтэвчийн үлдэгдэл',
    deposit_pending_title: 'Нэвтрүүлэг хүлээгдэж байна',
    deposit_pending_description: 'Таны нэвтрүүлэг одоогоор баталгаажуулалтыг хүлээж байна',
    deposit_success_title: 'Нэвтрүүлэг амжилттай',
    deposit_success_description: 'Мөнгө таны дансанд оруулсан',
    create_withdraw_success_title: 'Тасалдалын хүсэлт амжилттай',
    create_withdraw_success_description: 'Таны тасалдалын хүсэлт боловсруулах явцад байна',
    withdrawal_success_title: 'Мөнгө тасалдал амжилттай',
    withdrawal_success_description: 'Таны тасалдалын хүсэлтийг дуусгалаа',
    amount_required: 'Мөнгөн дүн оруулах шаардлагатай',
    amount_exceeds_available: 'Хэмжээ нь боломжтой үлдэгдлээс илүү байна',
    amount_below_minimum: 'Хэмжээ нь хамгийн бага хязгаар дотор байна',
    amount_below_fee: 'Хэмжээ нь гарах зардлаас доош байна',
    invalid_number: 'Тодорхойгүй тоо',
    network_required: 'Сүлжээ сонгох шаардлагатай',
    address_required: 'Хаяг оруулах шаардлагатай',
    blockchain_required: 'Блокчейн сонгох шаардлагатай',
    email_required: 'И-мэйл оруулах шаардлагатай',
    valid_amount: 'Үр дүнтэй тоог оруулна уу',
    notice: 'Мэдэгдэл',
    cancel: 'Цуцлах',
    cancel_transaction: 'Та гүйлгээг цуцалсан байна',

    from: 'Үүссэн',
    receive_amount: 'Хүлээн авалт',

    // 2FA
    two_fa_required_msg:
      'Аюулгүй байдлыг хангахын тулд таталдлын өмнө хоёр давхар баталгаажуулалтыг тохируулах шаардлагатай.',
    setup_2fa: 'Хоёр Давхар Баталгаажуулалт тохируулах',
    lost_my_2fa_access: 'Хоёр Давхар Баталгаажуулалт хаясан',

    wallets_usdt_token: 'Хэтэвчний USDT токен',
    memo_reminder_1:
      '{{memo}}-ийг тайлбар хэсэгт оруулснаа баталгаажуулна уу. Хэрэв буруу оруулсан бол манай систем таны данс руу мөнгө байршуулах боломжгүй.',
    memo_reminder_2: 'Хэрэв та TonConnect ашиглаж байгаа бол систем автоматаар бөглөнө.',

    wait_for_next_lucky_draw:
      'Тоглоход шаардагдах мөнгө авах боломжтой дараагийн азтай сугалааны арга хэмжээг хүлээнэ үү.',
  },
  history_status: {
    completed: 'Дууссан',
    pending: 'Боловсруулж байна',
  },
  transaction_history: {
    tab_titles: {
      all_flow: 'Бүх гүйлгээ',
      deposits: 'Нэвтрүүлэг',
      withdrawals: 'Тасалдал',
      bets: 'Тавьдаг',
      purchase: 'Алтан худалдан авах',
      diamond: 'Алтан',
    },
    transaction_type: 'Гүйлгээний төрөл',
    transaction_types: {
      deposits: 'Нэвтрүүлэг',
      withdrawals: 'Тасалдал',
      bets: 'Тавьдаг',
      purchase: 'Алтан худалдан авах',
      diamond: 'Алтан',
      purchase_item: 'Алтан гүйлгээ',
      referral_commission: 'Холбоосын комисс',
      payout: 'Шагнал авах',
      private_room: 'Хувийн өрөө үүсгэх',
      private_room_rebate: 'Хувийн өрөөний буцаан авалт',
      reward: 'Шагнал',
      lucky_draw: 'Азтай шилжилт тоглох',
      tournament_prize: 'Тэмцээн шагнал',
      tournament_ticket_fee: 'Тэмцээн тээвэр',
    },
    game_type: 'Тоглоомын төрөл',
    type: 'Төрөл',
    bet: 'Тавьдаг',
    payout: 'Шагнал авах',
    amount: 'Хэмжээ',
    quantity: 'Тоо',
    balance: 'Үлдэгдэл',
    diamond: 'Алтан',
    sticker: 'Sticker',
  },
  referral: {
    referral: 'Холбоос',
    invite_friends_description: 'Найзуудаа Win4Poker-д урьж шагнал авах',
    whatsapp_referral_message:
      'Та ялахад бэлэн үү? 🃏 Win4Poker-д надад хамтдаа гайхамшигтай тоглоомын туршлагыг эдлэхийг урьж байна! Энэ бол миний урилга холбоос: ',
    number_of_referrals: 'Холбоосон тоо',
    referral_rewards: 'Холбоосын шагнал',
    my_commission: 'Миний комисс',
    referral_code: 'Холбоосын код',
    referral_link: 'Холбоосын холбоос',
    enter_code: 'Код оруулах',
    terms_and_conditions: 'Win4Poker нөхцөл ба нөхцөлүүд',
    invite_friends: 'Найзуудаа урь',
    pop_up_title: 'Мэдэгдэл',
    back_home: 'Нүүр хуудас руу буцах',
    scan_qr_code: 'QR кодыг скан хий',
    code: 'Код',
    copy_link: 'Холбоосыг хуул',
    save_image: 'Зураг хадгалах',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    more: 'Дэлгэрэнгүй',
    referral_history: 'Холбоосын түүх',
    register_time: 'Бүртгүүлсэн цаг',
    player: 'Тоглогч',
    reward_time: 'Шагнал авах цаг',
    reward_amount: 'Шагналын хэмжээ',
    referral_list: 'Холбоосын жагсаалт',
    enter: 'Оруулах',
    skip: 'Алгасах',
    please_input_referral_code: 'Холбоосын кодоо оруулна уу',
    enter_referral_code: 'Холбоосын кодоо оруулна уу',
    enter_referral_code_success: 'Холбоосын код амжилттай оруулсан',
    cannot_use_own_referral_code: 'Өөрийн холбоосын кодоо ашиглаж болохгүй',
    total: 'Нийт',
    referral_code_invalid: 'Холбоосын код буруу байна',
    commission: 'Комисс',
    reward_type: 'Шагналын төрөл',
    amount: 'Хэмжээ',
    commission_reward: 'Комиссийн шагнал',
    commission_update_success: 'Комиссийн шинэчлэлт амжилттай',
    commission_setting: 'Комиссийн тохиргоо',
    save: 'Хадгалах',

    // title
    promotion_1: 'Холбоос 1: Нэвтрүүлэгийн шагнал',
    promotion_2: 'Холбоос 2: Холбоосын кодын шагнал',
    general_terms: 'Ерөнхий нөхцөл ба нөхцөлүүд',

    // sub-title
    eligibility: 'Эрэмбэлэл',
    offer: 'Төлөвлөгөө',
    conditions: 'Нөхцөлүүд',
    program_duration: 'Төлөвлөгөөний хугацаа',
    account_verification: 'Дансын баталгаажуулалт',
    limitations: 'Хязгаарлал',
    modification_of_terms: 'Нөхцөлүүдийг засах',
    compliance: 'Хуулийн дагуу байх',
    support: 'Дэмжлэг',

    error_messages: {
      referral_code_invalid:
        'Дахин санал болгож буй код нь 4-8 тэмдэгттэй байх ёстой бөгөөд зөвхөн "I" болон "O"-г ор excluding тоогоор агуулж болно',
      referral_code_required: 'Өргөлтийн код шаардлагатай',
    },

    // points
    eligibility_1:
      'Хэрэглэгчид Win4Poker дансанд 1 USDT-с дээш хөрөнгө оруулсан байх шаардлагатай.',
    offer_1: 'Эрэмбэлэлд нийцсэн хэрэглэгчид дансанд шууд 1 USDT үнэгүй бэлэг авна.',
    conditions_1: 'Энэ сурталчилгааны ямар ч хязгаарлалгүй байна.',
    conditions_2: 'Хөрөнгө оруулалт Win4Poker-ийн тодорхойлсон холбоосын хугацаанд дуусна.',
    conditions_3: 'Хэрэглэгчид бүрэн баталгаажуулсан дансийг ашиглах шаардлагатай байна.',

    eligibility_2:
      'Хэрэглэгчид найзуудаа өөрийн өвөрмөц холбоосын код ашиглан холбоослох шаардлагатай.',
    offer_2:
      'Холбоослогдсон найз нь анхны тоглоомоо дуусгаснаар холбоослогчид хамгийн их pot-ийн нийт хэмжээний 3.5% шагнал авна.',
    conditions_4: 'Холбоослогдсон найз нь холбоослогчийн код ашиглан бүртгүүлэх ёстой.',
    conditions_5: 'Шагналууд найз тоглоомоо дуусгасны 2 цагийн дотор түүнд нийлүүлнэ.',
    conditions_6: 'Хэрэглэгчид өөрийн дансны самбар дээр холбоос ба шагналын хянах боломжтой.',
    program_duration_1:
      'Эдгээр холбоосын үйл ажиллагаа манай вэбсайт ба албан ёсны сувгууд дээр заасан хугацаанд явуулна.',
    account_verification_1:
      'Оролцогчид аливаа шагналд нийцэхийн тулд бүрэн баталгаажуулсан данс байх шаардлагатай.',
    limitations_1:
      'Холбоос системийг золиослох (жишээ нь өөрөө холбоослох) зэрэг муу үйлдэл илрүүлсэн хэрэглэгчид данс нь түр зогсоож эсвэл хориглоно.',
    modification_of_terms_1:
      'Win4Poker нь ямар ч үед эдгээр холбоосын үйл ажиллагааг засварлах эсвэл зогсоох эрхийг хадгалдаг бөгөөд өмнө мэдэгдэхгүй.',
    compliance_1:
      'Оролцогчид онлайн тоглоом ба холбоосын холбоотой хууль эрхийн дүрэм журмыг дагаж мөрдөх шаардлагатай.',
    support_1:
      'Холбоосын төлөвлөгөөтэй холбоотой асуулт эсвэл тусламж шаардлагатай бол манай хэрэглэгчийн дэмжлэгийн багт хандаарай.',

    // disclaimer
    disclaimer: 'Тодорхойлолт',
    disclaimer_1:
      'Бүх шагналууд нийлүүлэлтийн хязгаарлалтай бөгөөд дансны байдал ба үйл ажиллагааны дагуу өөр өөр болно.',
    disclaimer_2:
      'Win4Poker нь холбоосыг амжилттай хянах эсвэл шагнал авсан үйл явцыг таслах боломжтой аливаа техникийн асуудалд хариуцлага хүлээхгүй.',

    fixed_commission: 'Fixed Commission',
    custom_commission: 'Custom Commission',
    invalid_commission_percentage: 'Invalid commission percentage',
    commission_placeholder: 'Enter commission percentage',
    my_share: 'My Share',

    commission_calculation: {
      title: 'Комиссын тооцоолол',
      first_layer: '1-р давхарга %',
      second_layer: '2-р давхарга %',
      third_layer: '3-р давхарга %',
      refers: 'Холбоосууд',
      referrer: 'Холбоослогч',
      content:
        'Хожлын 5% нь комисс болж суутгагдана. Гейтвэй нь комиссын 30%-ийг <0>ХАМГИЙН ИХ</0> хүлээн авна. Гейтвэй нь комиссын үлдсэн 70%-ийг хамгийн дээд түвшний холбоослогчид хуваарилна, тэрээр комиссын 70%-иас Z%-ийг дараагийн түвшний холбоослогчдод хуваарилахаар шийдэх боломжтой. Дараагийн түвшний холбоослогч нь комиссын Z%-иас Y%-ийг доод түвшинд хуваарилахаар шийдэх боломжтой, энэ үйл явц комисс хожигч холбоослогчид хүрэх хүртэл үргэлжилнэ.',
      example: {
        title: 'Жишээ:',
        winner_wins: 'Хожигч хожсон дүн: ${{value}}',
        total_commission: 'Нийт комисс: ${{value}}',
        gateway_total_commission_max: 'Гейтвэйн нийт комисс (ХАМГИЙН ИХ): ${{value}}',
        referral_total_commission_min: 'Холбоосын нийт комисс (ХАМГИЙН БАГА): ${{value}}',

        referral_commissions: 'Холбоосын комиссууд (70 ≥ Z ≥ Y ≥ X ...):',
        referrer_1_commission: 'Холбоослогч 1: ${{totalCommission}} × (Z% - Y%)',
        referrer_2_commission: 'Холбоослогч 2: ${{totalCommission}} × (Y% - X%)',
        referrer_3_commission: 'Холбоослогч 3: ${{totalCommission}} × X%',
      },
    },
  },
  ranking: {
    ranking: 'Тооцоо',
    today: 'Өнөөдөр',
    this_week: 'Энэ долоо хоног',
    this_month: 'Энэ сар',
  },
  tournament: {
    you_have_won: 'Та хожсон',
    time_elapsed: 'Өнгөрсөн хугацаа',
    prize_pool: 'Шагналын сан',
    entries: 'Оролцогчид',
    of: '-н',
    congratulations: 'Баяр хүргэе',
    thanks_for_your_joining: 'Оролцсонд баярлалаа',
    watch: 'Үзэх',
    see_result: 'Үр дүнг харах',
    view_tournament: 'Тэмцээнийг харах',
    deregister: 'Бүртгэлээс хасах',
    start_in: '<0>countdown</0> дараа эхэлнэ',
    full: 'Дүүрэн',
    register_end_in: 'Бүртгэл <0>countdown</0> дараа дуусна',
    my_ranking: 'Миний зэрэглэл',
    players: 'Тоглогчид',
    register: 'Бүртгүүлэх',
    pay_for_registration: 'Бүртгүүлэхдээ {{ticketFee}} үнэтэй тасалбарын төлбөр төлөөд бүртгүүлнэ',
    register_confirmation_message:
      'Тэмцээнд бүртгүүлэхдээ {{ticketFee}} үнэтэй тасалбарын төлбөр төлөөд бүртгүүлнэ. {{tournamentName}} тэмцээнд бүртгүүлэх үү?',
    late_register: 'Хожуу бүртгүүлэх',
    level: 'Түвшин',
    blinds: 'Блайндууд (SB/BB)',
    ante: 'Анте',
    duration: 'Үргэлжлэх хугацаа',
    game_rule: 'Тоглоомын дүрэм',
    game_mode: 'Тоглоомын горим',
    speed: 'Хурд',
    general_information: 'Ерөнхий мэдээлэл',
    ticket_fee: 'Тасалбарын төлбөр',
    starting_stack: 'Эхлэх стак',
    blinds_start: 'Блайндын эхлэл',
    ante_starts: 'Антены эхлэл',
    raised_every: 'Өсөлт',
    minutes: 'минут тутамд',
    prize: 'Шагнал',
    structure: 'Бүтэц',
    gameModeTitle: {
      classic: 'Классик',
      turbo: 'Турбо',
      hyper: 'Хайпер',
    },
    gameModeDescription: {
      classic:
        'Классик олон ширээт тэмцээн, оролцогчид нийт шагналын сангаас хувь авахын төлөө өрсөлдөнө.',
    },
    speedTitle: {
      regular: 'Энгийн',
      turbo: 'Турбо',
      hyper: 'Хайпер',
    },
    speedDescription: 'Блайндууд {{value}} минут тутамд өсдөг',
    tournament: 'Тэмцээн',
    today: 'Өнөөдөр',
    yesterday: 'Өчигдөр',
    tomorrow: 'Маргааш',
    upcoming: 'Удахгүй болох',
    results: 'Үр дүнгүүд',
    on_going: 'Явагдаж байгаа',
    title: 'Тэмцээний дэлгэрэнгүй',
    tables: 'Ширээнүүд',
    minutes_short: 'мин',
    current_blinds: 'Одоогийн блайндууд',
    next_blind_at: 'Дараагийн блайнд',
    start_game_in: 'Тоглоом эхлэх',
    no_tournaments_available: 'Тэмцээн байхгүй байна',
    you_have_not_participated_in_any_tournament_yet: 'Та аль ч тэмцээнд оролцоогүй байна',
    tournament_started: 'Тэмцээн эхэллээ',
    tournament_ended_msg: 'Тэмцээн дууссан',
    tournament_canceled_msg: 'Тэмцээн цуцлагдсан',
    view_table: 'Ширээг харах',
    view_player_table: 'Тоглогчийн ширээг харах',
    table_rebalancing: 'Ширээнүүдийн үйлдэл',
    upcoming: 'Дараагийн тэмцээн',
    in_progress: 'Явагдаж байгаа тэмцээн',
    finished: 'Дууссан тэмцээн',
    waiting_enough_players_to_start: 'Тэмцээн эхлэхэд шаардлагатай ирээдүй тоглогч байна',
    cancelled: 'Тэмцээн цуцлагдсан',
    table_rebalancing: 'Ширээний тэнцвэржүүлэлт',
    too_many_rooms_description:
      '{{tournamentName}} удахгүй эхлэх гэж байна, гэхдээ та хамгийн их ширээний тоонд хүрсэн байна, {{tournamentName}}-д нэгдэхийн тулд дараах ширээнүүдээс дор хаяж 1-ийг орхино уу.',
    leave: 'Гарах',
    sit_in: '{{name}}-д суух',
    ignore: 'Үл тоох',

    re_entry_modal: {
      title: 'Тэмцээнд дахин орох уу?',
      description:
        '{{tournamentName}} тэмцээн үргэлжлүүлэн нээлттэй байна. Тэмцээнд дахин нэгдэхийн тулд ${{ticketFee}} үнэтэй тасалбар худалдаж авах уу?',
      re_enter: 'Дахин орох',
      view_tournament: 'Тэмцээнийг харах',
    },
    waiting_for_players: {
      title: 'Тоглогчдыг хүлээж байна',
      message: '{{count}} тоглогч нэгдэхийг хүлээж байна',
      message_plural: '{{count}} тоглогчид нэгдэхийг хүлээж байна',
    },
    thanks_for_joining: {
      title: 'Нэгдсэнд баярлалаа!',
      description: '{{tournamentName}} тэмцээнд оролцсонд баярлалаа. Тэмцээн үргэлжилж байгаа тул та үр дүнгээ дараа харах боломжтой.',
      view_results: 'Тэмцээний үр дүнг харах',
    },
    cancel: {
      title: 'Тэмцээн цуцлагдсан',
      description: '"{{tournamentName}}" тэмцээн цуцлагдсан байна.',
      refund_message: 'Таны элсэлтийн төлбөр ${{amount}} буцаагдах болно.',
      confirm: 'За',
    },
    waiting_timer: {
      title: 'Тоглогчдыг хүлээж байна',
      cancel_in: 'Цуцлах хүртэл',
    },
  },
  errorCodes: {
    default: {
      title: 'Системийн алдаа',
      message: 'Ямар нэг зүйл буруу болов, дараа дахин оролдоно уу',
    },

    WS_0000: 'Системийн алдаа',
    WS_0001: '4 өрөөнөөс илүүт орох боломжгүй',
    WS_0002: 'Хэт их тавьдаг тоглоом үед гарах боломжгүй',
    WS_0003: 'Баталгаажуулалтын алдаа, хуудсыг шинэчлэхийг оролдно уу',
    WS_0004: 'Өрөөнд ойрхон хүн байгааг илрүүлсэн тул одоогоор тэр өрөөнд орох боломжгүй',
    WS_0005: 'Их тавьдаг тоглогчийг гарах боломжгүй. Тавьгат үгүй болгоно уу',
    WS_0006: 'Худалдан авах алдаа',
    WS_0007: 'Тоглоомын өрөөг олсонгүй',

    HP_0001: '4 өрөөнөөс илүүт орох боломжгүй',
    HP_0002: 'Одоогийн сервертэй холбогдоход боломжгүй, дараа дахин оролдоно уу.',
    HP_0003: 'Худалдан авах хэмжээ хангалтгүй',
    HP_0004: 'Баталгаажуулах код буруу байна',
    INVALID_EMAIL_PASS_CODE: 'Баталгаажуулах код буруу байна',
    INVALID_OTP: 'Буруу баталгаажуулах код',
    INVALID_REFERRAL_CODE: 'Буруу урилгын код',
    REFERRAL_CODE_ALREADY_USED: 'Урилгын код аль хэдийн ашиглагдсан байна',
    INSUFFICIENT_COINS: 'Хэтэвчний үлдэгдэл хүрэлцэхгүй байна',
    JOIN_TOURNAMENT_ERROR: 'Тэмцээнд нэгдэхэд алдаа гарлаа',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: 'Байршлын хандалт татгалзагдсан.',
      POSITION_UNAVAILABLE: 'Байршлын мэдээлэл боломжгүй байна. Дараа дахин оролдоно уу.',
      TIMEOUT: 'Таны байршлыг авах хүсэлт хугацаа хэтэрсэн байна. Дахин оролдоно уу.',
      UNKNOWN: 'Таны байршлыг хүсэхэд үл мэдэгдэх алдаа гарлаа.',
    },
    TOURNAMENT_IS_FINISHED: 'Тэмцээн дууссан',
    GPS_RESTRICTION:
      'Байршлыг илрүүлэх боломжгүй эсвэл таны ойролцоо тоглогч ижил өрөөнд нэгдсэн байна, дараа дахин оролдоно уу',
  },
};
